import { Box } from '@mui/material';
import { m } from 'framer-motion';
import {
  BAR_SEGMENT_ANIMATION_DURATION,
  GRAPH_HEIGHT,
  GRAPH_WIDTH,
  SELECTED_COLOR,
  type BarSegment,
  type SelectedItem,
} from './constants';

type StackedBarGraphProps = {
  monthBarSegments: BarSegment[];
  selectedGradeBarSegment: BarSegment | null;
  selectedItem: SelectedItem;
};
export const StackedBarGraph = ({
  monthBarSegments,
  selectedGradeBarSegment,
  selectedItem,
}: StackedBarGraphProps) => (
  <Box
    borderRadius="12px"
    boxShadow="0 4px 4px 0 #00000040"
    height={GRAPH_HEIGHT}
    overflow="hidden"
    position="relative"
    width={GRAPH_WIDTH}
    sx={{ outline: '2px solid #CBD1D7' }}
  >
    <MonthBarSegments monthBarSegments={monthBarSegments} selectedItem={selectedItem} />
    {selectedGradeBarSegment && (
      <BarSegment
        backgroundColor={selectedGradeBarSegment.bgColor}
        bottom={selectedGradeBarSegment.barBottom}
        height={selectedGradeBarSegment.barHeight}
        key={selectedGradeBarSegment.value}
      />
    )}
  </Box>
);

type MonthBarSegmentsProps = { monthBarSegments: BarSegment[]; selectedItem: SelectedItem };
const MonthBarSegments = ({ monthBarSegments, selectedItem }: MonthBarSegmentsProps) => {
  const selectedMonth = selectedItem.type === 'month' ? selectedItem.data.value : null;
  return (
    <>
      {monthBarSegments.map(({ barBottom, barHeight, bgColor, value }, index) => (
        <BarSegment
          animate={{ delay: BAR_SEGMENT_ANIMATION_DURATION * index }}
          backgroundColor={value === selectedMonth ? SELECTED_COLOR : bgColor}
          bottom={barBottom}
          height={barHeight}
          key={value}
        />
      ))}
    </>
  );
};

type BarSegmentProps = {
  animate?: {
    delay: number;
  };
  backgroundColor: string;
  bottom: number;
  height: number;
};
const BarSegment = ({ animate, backgroundColor, bottom, height }: BarSegmentProps) => {
  const variants = {
    hidden: { height: 0 },
    visible: { height },
  };
  return (
    <m.div
      style={{
        alignItems: 'center',
        backgroundColor,
        bottom,
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        width: '100%',
      }}
      animate="visible"
      initial={animate ? 'hidden' : false}
      transition={{ duration: BAR_SEGMENT_ANIMATION_DURATION, delay: animate?.delay }}
      variants={variants}
    />
  );
};
